.customer-lead-step-quantities__container {
  flex: 1;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  & .ant-tabs {
    flex: 1;
  }

  & .ant-tabs-content, & .ant-tabs-tabpane, {
    height: 100%;
  }

  & .ant-tabs-nav {
    background-color: #F2F3F5;
    margin: 0 -100%;
    padding: 0 100%;
  }
}

@media screen and (width <= 640px) {
  .customer-lead-step-quantities__container {
    & .ant-tabs-nav {
      margin: 0 -16px;
      padding: 0 16px;
    }
  }
}
